import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CompanyUser } from '@models/users/company-user.model';
import { CompanyUserDetails } from '@models/users/company-user-details.model';

import { AppUtils } from '@app/shared/utils/app.utils';
import { QueryConfig } from '@app/shared/utils/query-config.utils';
import { PagedResponse } from '@models/commons/paged-response.model';

import { ColumnsPageType } from '@models/columns-page-type.enum';

import { Observable } from 'rxjs';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  static readonly API_USERS_BASE_PATH = `${environment.api.rest.users}`;

  constructor(private http: HttpClient) {
  }

  loadUsers(config: QueryConfig): Observable<PagedResponse<CompanyUser>> {
    const params = AppUtils.buildPageableParams(config);
    return this.http.get<PagedResponse<CompanyUser>>(`${UsersService.API_USERS_BASE_PATH}`, {params});
  }

  loadUser(id: number): Observable<CompanyUserDetails> {
    return this.http.get<CompanyUserDetails>(`${UsersService.API_USERS_BASE_PATH}/${id}`);
  }

  createUser(user: CompanyUserDetails): Observable<CompanyUserDetails> {
    return this.http.post<CompanyUserDetails>(`${UsersService.API_USERS_BASE_PATH}`, user);
  }

  updateUser(user: CompanyUserDetails): Observable<CompanyUserDetails> {
    return this.http.patch<CompanyUserDetails>(`${UsersService.API_USERS_BASE_PATH}/${user.id}`, user);
  }

  updateUserColumns(pageType: ColumnsPageType, columnsConfig: string): Observable<string> {
    return this.http.post(`${UsersService.API_USERS_BASE_PATH}/columns`, {
      pageType,
      columnsConfig
    }, {responseType: 'text'});
  }

  deleteUser(user: CompanyUser): Observable<number> {
    return this.http.delete<number>(`${UsersService.API_USERS_BASE_PATH}/${user.id}`);
  }
}
